// extracted by mini-css-extract-plugin
module.exports = {"danjiView":"DanjiView_danjiView__Wtc5_","watermark":"DanjiView_watermark__IY00h"};